module.exports = __webpack_public_path__ + "img/enterprise_setup_header.274642f7.svg";